const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/intake/ideas/all/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
import { ideaSchema } from '../view/$viewId';
export const allIdeasSchema = ideaSchema.extend({
  productAreaIds: z.array(z.number()).optional()
});
export const Route = createFileRoute('/(app)/org/$org/intake/ideas/all/')({
  validateSearch: zodValidator(allIdeasSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.ideaManagement.general.allIdeas)
    }
  }
});